import { createUserState } from "./atoms";
import { InputBase } from "../../../../components";

import { useRecoilState } from "recoil";
import React from "react";

type Props = {
  type: string;
  name: string;
  id?: string;
  className: string;
};

const Input: React.FC<Props> = ({
  type,
  id,
  name,
  className,
  ...props
}: Props) => {
  const [state, setState] = useRecoilState(createUserState);

  console.log("state", state);

  return (
    <InputBase
      {...props}
      type={type}
      id={id}
      name={name}
      state={state}
      setState={setState}
      className={className}
    />
  );
};

export default Input;
